<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><b>CONTENTS</b></span></p>
<p class="toc_hd" id="rsec1"><a href="#/text/Frontmatter2#sec1"><i>Note on Transliteration</i></a></p>
<p class="toc_hd" id="rsec2"><a href="#/text/Acknowledgments#sec2"><i>Acknowledgments</i></a></p>
<p class="toc_ht" id="rsec3"><a href="#/text/Introduction#sec3">Introduction</a></p>
<p class="toc_c" id="rsec4"><span href="#/text/Chapter_1#sec4" title="Link target outside of Sample">1.<span class="space">Men of Letters</span></span></p>
<p class="toc_c" id="rsec5"><span href="#/text/Chapter_2#sec5" title="Link target outside of Sample">2.<span class="space">How the Word Became Flesh</span></span></p>
<p class="toc_c" id="rsec6"><span href="#/text/Chapter_3#sec6" title="Link target outside of Sample">3.<span class="space">Texts on Trial</span></span></p>
<p class="toc_c" id="rsec7"><span href="#/text/Chapter_4#sec7" title="Link target outside of Sample">4.<span class="space">Literary Apostasy</span></span></p>
<p class="toc_c" id="rsec8"><span href="#/text/Chapter_5#sec8" title="Link target outside of Sample">5.<span class="space">Readers’ Paradise</span></span></p>
<p class="toc_c " id="rsec9"><span href="#/text/Chapter_6#sec9" title="Link target outside of Sample">6.<span class="space">The Talmudic Passion</span></span></p>
<p class="toc" id="rsec10"><span href="#/text/Epilogue#sec10" title="Link target outside of Sample">Epilogue: Reflections on the Value of Literature</span></p>
<p class="toc_ht" id="rsec11"><span href="#/text/Bibliography#sec11" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc_hd" id="rsec12"><span href="#/text/Index#sec12" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?03d06afe